import React, { useEffect, useState } from 'react';
import { Federation, User } from "../typings";
import { Row } from "../components/Flex";
import { useParams } from "react-router-dom";
import { PrimaryButton } from "../components/buttons/Buttons";
import { useAuth } from "../auth-context";
import { toast } from "react-toastify";
import { useApi } from "../api-context";
import { fetchFederation, updateFederation } from "./federations-api";
import EditableInput from "../components/EditableInput";
import { setFips } from "crypto";

function FederationPage() {
    const api = useApi();
    const [federation, setFederation] = useState<Federation>();

    const { id } = useParams();

    const loadFederation = () => {
        if (!id) {
            return;
        }
        fetchFederation(api, Number(id))
            .then(setFederation)
            .catch(console.error);
    };

    const onUpdateFederation = () => {
        if (!federation) {
            return;
        }
        updateFederation(api, Number(id), { name: federation.name })
            .then(() => toast.success('Saved changes'))
            .catch(() => toast.error('Failed to save changes'));
    };

    useEffect(() => {
        loadFederation();
    }, []);

    return (
        <>
            <div className="group-page-header">
                <Row gap={8}>
                    <div style={{ flex: 1 }}>
                        <EditableInput
                            value={federation?.name || ''}
                            setValue={name => {
                                setFederation({ ...federation!, name });
                            }}
                        />
                    </div>
                    <PrimaryButton
                        label="SAVE"
                        style={{ flex: 0, minWidth: '150px' }}
                        onClick={onUpdateFederation}
                    />
                </Row>
            </div>
            <div className="page-container">
                <div className="content-container" style={{ marginBottom: '32px' }}>
                    <div style={{ display: 'flex', gap: '16px', width: '100%' }}>
                        <div className="box" style={{ flex: 1, gap: '12px' }}>
                            <div className="ingo-title">Portals</div>
                            {federation?.portals?.map(portal => (
                                <div className="label">{portal}</div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default FederationPage;
